import styled from "styled-components";
import { Button, Flex, Type } from "@ebscois/react-component-library";

export const BoxedWarningButton = styled(Button)`
  ${({ theme }) => `
    font-family: ${theme.font.family.base};
    color: ${theme.colors.septenary.light};
    font-size: ${theme.font.size.md};
    font-weight: ${theme.font.weight.bold};
    margin-left: ${theme.space.sm};
    vertical-align: middle;
  `};
`;

export const StyledBoxedWarningTitle = styled(Type)`
  vertical-align: middle;
  display: flex;
`;

export const StyledTitleFlex = styled(Flex)`
  padding-top: 0.5rem;
`;

export const StyledContentFlex = styled(Flex)`
  padding-bottom: 1rem;
`;
